export class RoleModel {
	public id: string;
	public name: string;
	public description: string;
	public menus: string[];
	public access: string[];
	public numUser: number;
	public predefined: boolean;
	public checked: boolean;

	public convert(dto: any): RoleModel {
		if (dto.id) {
			this.id = dto.id;
		}
		if (dto.name) {
			this.name = dto.name;
		}
		if (dto.description) {
			this.description = dto.description;
		}
		if (dto.menus) {
			this.menus = dto.menus;
		}
		if (dto.access) {
			this.access = dto.access;
		}
		if (dto.numUser) {
			this.numUser = dto.numUser;
		}
		if (dto.predefined) {
			this.predefined = dto.predefined;
		}
		if (dto.checked) {
			this.checked = dto.checked;
		}

		return this;
	}
}
